import React, { memo } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import Container from '@mui/material/Container'
import Typography from '@mui/material/Typography'
import Grid from '@mui/material/Grid2'
import Box from '@mui/material/Box'
import useMediaQuery from '@mui/material/useMediaQuery'
import Image from 'components/shared/Image'
import EasyCarIcon from 'public/img/easy/Easycar.svg'
import EasyButton from 'components/Easy/EasyButton'
import MainEasyImage from 'public/img/easy/vendio-compro.webp'
import MainEasyImageMobile from 'public/img/easy/easy_main_mobile.webp'
import MainEasyAgenciasImage from 'public/img/easy/Te_yudamos_a_vender_mas_autos_mas_rapido.webp'
import MainEasyAgenciasImageMobile from 'public/img/easy/Banner_Easy_agencias_Mobile-min.webp'
import EasyWhatsappLink from 'components/Easy/EasyWhatsappLink'
import sx from './styles'

const MainSection = (prop) => {
  const {
    title = 'EASY_MAIN_TITLE',
    subtitle = 'EASY_MAIN_SUBTITLE',
    isEasyAgencias = false,
    onClickButton,
    onClickWhatsappButton,
    showWhatsappButton = false,
  } = prop

  const isMobile = useMediaQuery((theme) => theme.breakpoints.down('md'))
  const { formatMessage: f } = useIntl()

  return (
    <>
      <Container id="Inicio">
        <Grid
          container
          sx={sx.root}
        >

          <Grid
            size={12}
            display="flex"
            alignItems="center"
            flexDirection="column"
          >
            <Typography
              component="h1"
              textAlign="center"
              variant="p"
              sx={sx.herotitle}
            >
              <FormattedMessage id={title} />
            </Typography>

            <Box my={3}>
              <EasyCarIcon />
            </Box>

            <Typography
              component="h2"
              align="center"
              sx={sx.subtitle}
              variant="h1"
            >
              <FormattedMessage id={subtitle} />
            </Typography>
          </Grid>

          <Grid
            size={12}
            sx={sx.cts}
          >
            <EasyButton
              showIcon={!isEasyAgencias}
              cta={isEasyAgencias ? 'EASY_IM_INTERESTED' : 'EASY_MAIN_CTA'}
              handleClick={onClickButton}
            />
            {showWhatsappButton && (
              <EasyWhatsappLink onClickWhatsapp={onClickWhatsappButton} />
            )}
          </Grid>

          {isMobile ? (
            <Box
              mt={3}
              style={sx.mainBannerMobile}
            >
              <Image
                title={f({ id: 'EASY_MAIN_TITLE' })}
                src={isEasyAgencias ? MainEasyAgenciasImageMobile : MainEasyImageMobile}
                fill
                placeholder="blur"
                alt={f({ id: 'EASY_MAIN_TITLE' })}
                width="100%"
                height="395px"
                priority
                unoptimized
              />
            </Box>
          )
            : (
              <Grid
                size={12}
                style={sx.mainBanner}
              >
                <Image
                  title={f({ id: 'EASY_MAIN_TITLE' })}
                  src={isEasyAgencias ? MainEasyAgenciasImage : MainEasyImage}
                  fill
                  placeholder="blur"
                  alt={f({ id: 'EASY_MAIN_TITLE' })}
                  width="100%"
                  height="330px"
                  priority
                  unoptimized
                />
              </Grid>
            )}

        </Grid>
      </Container>
    </>
  )
}

export default memo(MainSection)
